"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAuthTokenForEndpoint = void 0;
const contentTypes = require("./content-types");
const registry_call_1 = require("./registry-call");
const needle_1 = require("./needle");
/**
 * Retrieves an authentication token for endpoint.
 *
 * Authentication uses the general HTTP authentication framework.
 * https://developer.mozilla.org/en-US/docs/Web/HTTP/Guides/Authentication
 *
 * @returns Returns authentication token when endpoint requires authentication.
 * @returns Returns null when endpoint does not require authentication.
 * @throws Throws when credentials are invalid.
 */
async function getAuthTokenForEndpoint(registryBase, endpoint, username, password, reqOptions = {}) {
    const reqConfig = (0, registry_call_1.buildUnauthenticatedV2RequestConfig)(registryBase, endpoint, contentTypes.JSON, reqOptions);
    try {
        await (0, needle_1.needleWrapper)(reqConfig);
        return null;
    }
    catch (err) {
        if (err.statusCode !== 401) {
            throw err;
        }
        const challengeHeaders = err.headers["www-authenticate"];
        if (!challengeHeaders) {
            return null;
        }
        const [authBase, service, scope] = (0, registry_call_1.parseChallengeHeaders)(challengeHeaders);
        if (!authBase) {
            return null;
        }
        else {
            // Bearer token
            const token = await (0, registry_call_1.getToken)(registryBase, authBase, service, scope, username, password, reqOptions);
            return token;
        }
    }
}
exports.getAuthTokenForEndpoint = getAuthTokenForEndpoint;
//# sourceMappingURL=get-auth-token-for-endpoint.js.map